import settings from '../helpers/settings';
import * as utils from '../helpers/utils';

let commons = {
	$html: settings.get('$html'),
	$footer: settings.get('$footer'),
	footerHeight: settings.get('$footer').find('.footer-content').outerHeight(),
	$header: settings.get('$header'),
	$page: settings.get('$mazPage'),
	isDesktop: null,
	pageIsHome: null,

	handleWishlistErrorMessage: {
		fr: 'Impossible de mettre/enlever ce lot de votre liste de favoris. Veuillez réessayer plus tard.',
		en: 'Unable to add/remove this lot from your favorites list. Please Try again later.',
		zh: '无法从收藏夹列表中添加/删除此批次。 请稍后再试。'
	},

	init: function () {
		this.pageIsHome = settings.get('$body').hasClass('path-frontpage');

		if (this.pageIsHome && settings.get('scrollTop') !== 0) {
			if (settings.get('windowSize').width > 1140) {
				this.$header.css('height', 75);
				this.$page.css('margin-top', 75);
			}
		}

		this.windowResize();
		settings.get('$win').on('resize', this.windowResize.bind(this));

		this.updateFooterMarginBefore();

		// Using event delegation by adding the eventListener on #mazPage
		// To avoid looping and assigning the event on each ".maz-tooltip".
		['click', 'touchstart'].forEach(function (item) {
			commons.$page[0].addEventListener(item, function (e) {
				if (e.target.classList.contains('maz-tooltip')) {
					e.type === 'touchstart' ? e.stopPropagation() : e.preventDefault();
				}
			}, false);
		});
	},

	wrapElement: function (el, wrapper) {
		el.parentNode.insertBefore(wrapper, el);
		wrapper.appendChild(el);
	},

	windowResize: function () {
		let test = this.isDesktop;
		this.isDesktop = settings.get('isDesktop'); // True if width > 1140

		if (this.isDesktop !== null && test !== this.isDesktop) {
			this.$html[this.isDesktop ? 'addClass' : 'removeClass']('desktop');
			this.$html[this.isDesktop ? 'removeClass' : 'addClass']('no-desktop');
		}

		this.updateFooterMarginBefore();
	},

	updateFooterMarginBefore: function () {
		let screenWidthIsTabletPortraitAndDown                = (settings.get('windowSize').width < 801),
			screenHeightIsLessThanFooterHeight                = (settings.get('windowSize').height < this.footerHeight),
			pageContentPlusHeaderHeightIsLessThanFooterHeight = (this.$header.outerHeight() + this.$page.outerHeight()) < this.footerHeight,

			test                                              = screenWidthIsTabletPortraitAndDown || screenHeightIsLessThanFooterHeight || pageContentPlusHeaderHeightIsLessThanFooterHeight;

		this.footerHeight = this.$footer.find('.footer-content').outerHeight();

		this.$footer.css({
			'position': test ? 'relative' : 'fixed',
			'height': this.footerHeight
		});

		this.$page.css('margin-bottom', test ? 0 : this.footerHeight);
	},

	//ToggleAccordions needs title, item and open item classes
	// E, heightToggler, titleClass, itemClass, openItemClass, callback
	toggleAccordions: function (e, params) {
		// Console.log('Inside toggleAccordions');
		if (e.target !== e.currentTarget && e.target.classList.contains(params.titleClass)) {
			let toggler = e.target,
				content = e.target.parentNode.nextElementSibling;

			while (!toggler.classList.contains(params.itemClass)) {
				toggler = toggler.parentNode;
			}

			if (!toggler.classList.contains(params.openItemClass)) {
				toggler.classList.add(params.openItemClass);
				params.heightToggler.expand(content);
				if (params.callback) {
					params.callback(content);
				}
			} else {
				toggler.classList.remove(params.openItemClass);
				params.heightToggler.collapse(content);
				if (params.callback) {
					params.callback(content);
				}
			}

			e.stopPropagation();

		}

	},

	// Used to edit live biding links on page-vente, page-lot and page-calendar
	// By appending the customer number at the end of each occurence.
	updateLiveBiddingLinks: function (liveBiddingLinks, custnoValue) {
		for (let i = 0, l = liveBiddingLinks.length; i < l; i++) {
			liveBiddingLinks[i].href = liveBiddingLinks[i].getAttribute('href') + '&custno=' + custnoValue;
		}
	},

	createLiveBiddingLinks: function (liveLinksInfos) {
		let self    = this,
			ajaxUrl = `../../${window.drupalSettings.path.pathPrefix}ajax/link_bidding?_format=json&context=${liveLinksInfos.context}&id=${liveLinksInfos.id}`;

		$.ajax({
			url: ajaxUrl,
			type: 'GET',
			dataType: 'json',

			success: function (response, statut) {
				let liveLinks  = response.links;
				let url = liveLinks[0].url;
                let ctaParent  = document.querySelector('.product-features__cta');
                let livestream = response.livestream;
                let ctaClasses = 'button product-features__link button--blue live-bidding-link';

				if (liveLinks && liveLinks.length) {
					for (let i = 0, l = liveLinks.length; i < l; i++) {
						self.domBiddingLinkCreator(liveLinks[i], ctaParent, ctaClasses);
					}
				}

				if (livestream) {
					let livestreamElement = document.querySelector('.page-vente .livestream-div-item');
					if (livestreamElement) {
						livestreamElement.classList.add('show');
						livestreamElement.querySelector('a span').textContent = livestream.title;
						livestreamElement.querySelector('a').href = livestream.url;
					}
				}
			},

			error: function (result, statut, error) {
				console.log('An error occured while trying to create the live bidding list.');
			}
		});
	},

	domBiddingLinkCreator: function (item, ctaParent, ctaClasses) {
		// Classes: button product-features__link button--blue live-bidding-link
		// Target: _blank
		// InnerText: liveLinks[i].title
		// Href: liveLinks[i].href

		let newLink = document.createElement('a');

		newLink.href = item.url;
		newLink.innerText = item.title;
		newLink.className = ctaClasses;

        if (item.title === 'Online Only') {
            newLink.className = 'button product-features__link button--green-blue live-bidding-link';
        }

		if (item.url === 'https://www.drouotlive.com') {
			newLink.setAttribute('target', '_blank');
		}

		ctaParent.appendChild(newLink);
	},

	// Method used to determine if the lot is already favorited on load page.
	// An ajax request is fired. The reponse contains a small json with either
	// "lotInFavorite": true or "lotInFavorite": false
	isLotInFavorite: function () {
		// Console.log('Inside isLotInFavorite');

		let saleId   = window.drupalSettings.sale.id,
			lotId    = window.drupalSettings.lot.number,
			wishLink = document.querySelector('.product-features__favorite .wishlist-link'),
			//TODO: erase this ternary
			//Window.drupalSettings.path.pathPrefix has a / at the end. Example: 'fr/' or 'zh/'
			ajaxUrl  = (window.drupalSettings.drupalEnv === false) ? '/json/lot-in-favorite.json' : `../../${window.drupalSettings.path.pathPrefix}ajax/get_favorites?_format=json&sale=${saleId}&lot=${lotId}`;

		$.ajax({
			url: ajaxUrl,
			type: 'GET',
			dataType: 'json',

			success: function (response, statut) {
				if (response.lotInFavorite) {
					wishLink.classList.add('wishlist-link--active');
				}
			},

			error: function (result, statut, error) {
				console.log('Error An error occured while trying to check if lot is in favorite.');
			}
		});
	},

	// Method is used to retrieve all lots in user's favorites list on page vente.
	// An ajax request is fired: the response contains an array of these lots.
	getSaleFavorites: function () {
		// Console.log('Inside getSaleFavorites');

		// Let saleId  = parseInt(window.drupalSettings.sale.id, 10),
		// No more parseInt, because an id can contain Letters
		let saleId  = window.drupalSettings.sale.id,
			//TODO: erase this ternary
			//Window.drupalSettings.path.pathPrefix has a / at the end. Example: 'fr/' or 'zh/'
			ajaxUrl = (window.drupalSettings.drupalEnv === false) ? '/json/retrieve-wishlist.json' : `../../${window.drupalSettings.path.pathPrefix}ajax/get_favorites?_format=json&sale=${saleId}`;

		$.ajax({
			url: ajaxUrl,
			type: 'GET',
			dataType: 'json',

			success: function (response, statut) {
				// Loop trhough all items only if the array of lots is > 0
				if (!response.wishlist.length) {
					window.wishlistNbArr = [];
				} else {
					let mosaicItemsArr = document.querySelectorAll('#mosaic__products .mosaic__item'),
						testArray      = ['1', '2', '3', '4', '5', '10', '12', '13', '16', '19', '24', '26', '32', '35', '42', '46', '50'],
						wishListArr    = response.wishlist.length ? response.wishlist : testArray,
						wishlistNbArr  = [];

					wishListArr.forEach(function (item) {
						if (Number.isInteger(item)) {
							wishlistNbArr.push(item);
						} else {
							wishlistNbArr.push(parseInt(item, 10));
						}
					});

					// Make the wishListArr available in page-vente.js
					// Inside handleLotsFromLoadMore method.
					// If user is not logged, this array is initialized directly in header.js (see windowLoad method)
					window.wishlistNbArr = wishlistNbArr;

					for (let indexItem = 0, lengthItems = mosaicItemsArr.length; indexItem < lengthItems; indexItem++) {
						for (let indexWish = 0, lengthWish = wishlistNbArr.length; indexWish < lengthWish; indexWish++) {
							let itemLotNb = parseInt(mosaicItemsArr[indexItem].getAttribute('data-lotnumber'), 10),
								lotNb     = wishlistNbArr[indexWish];

							if (itemLotNb === lotNb) {
								mosaicItemsArr[indexItem].querySelectorAll('.wishlist-link').forEach(function (item) {
									item.classList.add('wishlist-link--active');
								});
							}
						}
					}
				}
			},

			error: function (result, statut, error) {
				console.log('Error An error occured while trying to fetch sale favorites.');
			}
		});
	},

	// On lot page:
	//DrupalSettings.sale.id => represents the sale ID
	//DrupalSettings.lot.number => represents the actual lot number

	//On sale page:
	//DrupalSettings.sale.id => also represents the sale ID
	//Data-lotnumber on each  <div class="mosaic__item"> represents the corresponding lot number.
	handleWishlist: function (e) {
		// Console.log('Inside handleWishlist');

		let target        = e.target, // <i>
			currentTarget = e.currentTarget, // <element> that has the actual eventListener (using delegate technique to avoid creating lots of listeners)
			item;

		(currentTarget.id === 'mosaic__products') ? (item = $(target).closest('.mosaic__item')[0] || null) : (item = target.parentNode || null);

		if (target && target.parentNode.classList.contains('wishlist-link')) {
			e.preventDefault();

			// Custno: User ID. This value is inside the "Drupal.visitor.rfc.client.id".
			// Salelot: Concatenation of the sale ID and the lot number.
			// Track: 1 to add to favorites, 0 to remove.
			let custno    = utils.getCookie('Drupal.visitor.rfc.client.id'),
				saleId    = window.drupalSettings.sale.id,
                lotNumber = target.parentNode.getAttribute('data-lotnumber') || window.drupalSettings.lot.number,
                catalogDate = window.drupalSettings.fav.catalogDate,
                catalogTime = window.drupalSettings.fav.catalogTime,
				track     = target.parentNode.classList.contains('wishlist-link--active') ? 0 : 1;

			// TODO: When working, link needs to bee '../../ajax/set_favorites?_format=json&sale='
			// (can use http://artcurial.local/ajax/... for testing)
			//Window.drupalSettings.path.pathPrefix has a / at the end. Example: 'fr/' or 'zh/'
			let ajaxUrl = `../../${window.drupalSettings.path.pathPrefix}ajax/set_favorites?_format=json&sale=${saleId}&lot=${lotNumber}&track=${track}&catalogDate=${catalogDate}&catalogTime=${catalogTime}`; //PROD VERSION
			// Let ajaxUrl       = '/ajax/set_favorites?_format=json&sale=' + saleId + '&lot=' + lotNumber + '&track=' + track; //LOCAL DEV VERSION

			$.ajax({
				url: ajaxUrl,
				type: 'GET',
				dataType: 'json',

				success: function (response, statut) {
					if (response.success) {
						if (track === 1) {
							if (item.classList.contains('mosaic__item')) {
								item.querySelectorAll('.wishlist-link').forEach(function (currentItem) {
									currentItem.classList.add('wishlist-link--active');
								});
							} else {
								//No need for querySelector here
								item.classList.add('wishlist-link--active');
							}
						} else {
							if (item.classList.contains('mosaic__item')) {
								item.querySelectorAll('.wishlist-link').forEach(function (currentItem) {
									currentItem.classList.remove('wishlist-link--active');
								});
							} else {
								//No need for querySelector here as well
								item.classList.remove('wishlist-link--active');
							}
						}
					} else {
						// Handle an error message in case the response.success is false
						// (Even if the ajax request works). Maybe display a message generated by backend
						// Instead of creating it in this file ?
						if (window.drupalSettings.path.pathPrefix === 'fr/') {
							alert(commons.handleWishlistErrorMessage.fr);
						} else if (window.drupalSettings.path.pathPrefix === 'en/') {
							alert(commons.handleWishlistErrorMessage.en);
						} else {
							alert(commons.handleWishlistErrorMessage.zh);
						}
					}
				},

				error: function (result, statut, error) {
					console.log('An error occured while trying to fetch the wishlist.');
				}
			});

		}
	},

	appendConnectionPopinClassOnHearts: function (pageName) {
		// Console.log('Inside appendWishlistPopinClassOnHearts!');

		if (pageName === 'page-vente') {
			let mosaicProducts = document.getElementById('mosaic__products');

			if (mosaicProducts !== null) {
				let wishlistLinks = mosaicProducts.querySelectorAll('.wishlist-link');

				mosaicProducts.addEventListener('click', function (e) {
					if (e.target && e.target.classList.contains('wishlist-link')) {
						e.target.preventDefault();
					}
				});

				if (mosaicProducts.length || mosaicProducts !== null) {
					for (let i = 0, l = wishlistLinks.length; i < l; i++) {
						wishlistLinks[i].classList.add('open-popin-js');
						wishlistLinks[i].dataset.popin = 'connection';
					}
				}
			}
		} else if (pageName === 'page-lot') {
			let wishLink = document.querySelector('.product-features__favorite .wishlist-link');

			if (wishLink !== null) {
				wishLink.classList.add('open-popin-js');
				wishLink.dataset.popin = 'connection';
			}
		}
	}

};

export default commons;



// WEBPACK FOOTER //
// ./src/js/components/commons.js